import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Formio } from 'formiojs';
import { Guid } from 'guid-typescript';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppService } from '../app.service';
import { FormioExport } from 'formio-export';

@Component({
  selector: 'app-wa-application-component',
  templateUrl: './wa-application.component.html'
})
export class WAApplicationComponent {
    formSpec: any;
    formData: any;
    formId = Guid.create().toJSON().value;
    router: Router;
    httpClient: HttpClient;
    appService: AppService;
    baseUrl: string;
    ngxLoader: NgxUiLoaderService;
    jsonDataUrl: string;
    constructor(router: Router, appService: AppService, httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, ngxLoader: NgxUiLoaderService, private route: ActivatedRoute) {
        this.router = router;
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.appService = appService;
        this.ngxLoader = ngxLoader;
        this.route.queryParamMap
          .subscribe(params => {
            this.jsonDataUrl = params.get('jsonUrl')
        });
    }
  ngOnInit(){
    var formData;
    var httpClient = this.httpClient;
    var baseUrl = this.baseUrl;
    var that = this;
    var jsonDataUrl = this.jsonDataUrl;
    var formId = this.formId;

    var formComponents = [
      //   {
      //     "type": "radio",
      //     "label": "Agreement with intro info",
      //     "input": true,
      //     "inline": true,
      //     "tableView": false,
      //     "key": "agreementWithIntroInfo",
      //     "persistent": true,
      //       values: [
      //         {value: 'yes', label: 'Yes'},
      //         {value: 'no', label: 'No'}
      //       ],
      //       "validate": {
      //         "required": true
      //     }
      //   }
      // {
      //   "type": "htmlelement",
      //   "input": false,
      //   "tableView": true,
      //   "content": "Applicant",
      //   "inputMask": "",
      //   "key": "applicantText",
      //   "prefix": "",
      //   "suffix": "",
      //   "multiple": false,
      //   "protected": false,
      //   "unique": false,
      //   "persistent": true
      // },
      // {
      //   "type": "textfield",
      //   "input": true,
      //   "tableView": true,
      //   "inputType": "text",
      //   "inputMask": "",
      //   "label": "name",
      //   "key": "applicantName",
      //   "placeholder": "",
      //   "prefix": "",
      //   "suffix": "",
      //   "multiple": false,
      //   "defaultValue": "",
      //   "protected": false,
      //   "unique": false,
      //   "persistent": true,
      //   "validate": {
      //       "required": true,
      //       "customPrivate": false
      //   }
      // },
      // {
      //   "type": "textfield",
      //   "input": true,
      //   "tableView": true,
      //   "inputType": "text",
      //   "inputMask": "",
      //   "label": "ABN/ACN",
      //   "key": "applicantABN",
      //   "placeholder": "",
      //   "prefix": "",
      //   "suffix": "",
      //   "multiple": false,
      //   "defaultValue": "",
      //   "protected": false,
      //   "unique": false,
      //   "persistent": true,
      //   "validate": {
      //       "required": true,
      //       "customPrivate": false
      //   }
      // },
      //   {
      //     "type": "button",
      //     "label": "Check",
      //     "key": "check",
      //     "disableOnInvalid": false,
      //     "input": true,
      //     "tableView": true,
      //     "action": "custom",
      //     "custom": "window.onCheck(data.applicantABN)"
      //   },
      //   {
      //     "type": "htmlelement",
      //     "input": false,
      //     "tableView": true,
      //     "content": "ABN is valid",
      //     "inputMask": "",
      //     "key": "abnValidText",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "customClass": "abnSuccess",
      //     "conditional": {
      //       "json": {
      //         "==": [
      //           {
      //             "var": "data.displayabnValidationSuccess"
      //           },
      //           true
      //         ]
      //       }
      //     }
      // },
      // {
      //     "type": "htmlelement",
      //     "input": false,
      //     "tableView": true,
      //     "content": "ABN is not valid",
      //     "inputMask": "",
      //     "key": "abnNotValidText",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "customClass": "abnFailure",
      //     "conditional": {
      //       "json": {
      //         "==": [
      //           {
      //             "var": "data.displayabnValidationFailure"
      //           },
      //           true
      //         ]
      //       }
      //     }
      // },
      //   // Start - Address, tele and email
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "Postal Address",
      //     "key": "applicantPostalAddress",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false
      //     }
      //   },
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "Suburb",
      //     "key": "applicantSuburb",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false
      //     }
      //   },
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "State",
      //     "key": "applicantState",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false
      //     }
      //   },
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "PostCode",
      //     "key": "applicantPostCode",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false,
      //         "pattern": "^[0-9]+$"
      //     }
      //   },
      //   {
      //     "label": "Telephone number",
      //     "inputMask": "(99) 9999-9999",
      //     "tableView": true,
      //     "persistent": true,
      //     "validate": {
      //         "required": false,
      //         "customPrivate": false
      //     },
      //     "key": "applicantTelephoneNumber",
      //     "type": "textfield",
      //     "input": true
      //   },

      //   {
      //     "label": "Email",
      //     "tableView": true,
      //     "validate": {
      //         "required": true
      //     },
      //     "key": "applicantEmail",
      //     "type": "email",
      //     "input": true
      //   },
      //   // End - Address, tele and email
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "Name of the representative of the Applicant (if applicable)",
      //     "key": "nameOfRepresentativeOfApplicant",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true
      //   },
      //   {
      //     "type": "textarea",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "Roles and responsibilities of the Applicant under the construction contract",
      //     "key": "rolesAndResponsibilitiesOfTheApplicant",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true
      //   },
      //   // Respondent
      //   {
      //     "type": "htmlelement",
      //     "input": false,
      //     "tableView": true,
      //     "content": "Respondent",
      //     "inputMask": "",
      //     "key": "respondentText",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true
      // },
      // {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "name",
      //     "key": "respondentName",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false
      //     }
      //   },
      // // Add the abn check
      // {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "ABN/ACN",
      //     "key": "respondentABN",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false
      //     }
      //   },
      //   {
      //     "type": "button",
      //     "label": "Check",
      //     "key": "checkRespondentBN",
      //     "disableOnInvalid": false,
      //     "input": true,
      //     "tableView": true,
      //     "action": "custom",
      //     "custom": "window.onCheck1(data.respondentABN)"
      //   },
      //   {
      //     "type": "htmlelement",
      //     "input": false,
      //     "tableView": true,
      //     "content": "ABN is valid",
      //     "inputMask": "",
      //     "key": "abnValidTextRespondent",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "customClass": "abnSuccess",
      //     "conditional": {
      //       "json": {
      //         "==": [
      //           {
      //             "var": "data.displayabnValidationSuccessRespondent"
      //           },
      //           true
      //         ]
      //       }
      //     }
      // },
      // {
      //     "type": "htmlelement",
      //     "input": false,
      //     "tableView": true,
      //     "content": "ABN is not valid",
      //     "inputMask": "",
      //     "key": "abnNotValidTextRespondent",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "customClass": "abnFailure",
      //     "conditional": {
      //       "json": {
      //         "==": [
      //           {
      //             "var": "data.displayabnValidationFailureRespondent"
      //           },
      //           true
      //         ]
      //       }
      //     }
      // },        
      //   // Start - Address, tele and email
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "Postal Address",
      //     "key": "respondentPostalAddress",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false
      //     }
      //   },
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "Suburb",
      //     "key": "respondentSuburb",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false
      //     }
      //   },
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "State",
      //     "key": "respondentState",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false
      //     }
      //   },
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "PostCode",
      //     "key": "respondentPostCode",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true,
      //     "validate": {
      //         "required": true,
      //         "customPrivate": false,
      //         "pattern": "^[0-9]+$"
      //     }
      //   },
      //   {
      //     "label": "Telephone number",
      //     "inputMask": "(99) 9999-9999",
      //     "tableView": true,
      //     "persistent": true,
      //     "validate": {
      //         "required": false,
      //         "customPrivate": false
      //     },
      //     "key": "respondentTelephoneNumber",
      //     "type": "textfield",
      //     "input": true
      //   },

      //   {
      //     "label": "Email",
      //     "tableView": true,
      //     "validate": {
      //         "required": true
      //     },
      //     "key": "respondentEmail",
      //     "type": "email",
      //     "input": true
      //   },
      //   // End - Address, tele and email
      //   //Representative
      //   {
      //     "type": "textfield",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "Name of the representative of the Respondent (if applicable)",
      //     "key": "nameOfRepresentativeOfRespondent",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true
      //   },
      //   {
      //     "type": "textarea",
      //     "input": true,
      //     "tableView": true,
      //     "inputType": "text",
      //     "inputMask": "",
      //     "label": "Roles and responsibilities of the Respondent under the construction contract",
      //     "key": "rolesAndResponsibilitiesOfTheRespondent",
      //     "placeholder": "",
      //     "prefix": "",
      //     "suffix": "",
      //     "multiple": false,
      //     "defaultValue": "",
      //     "protected": false,
      //     "unique": false,
      //     "persistent": true
      //   },
      {
        "title": "WA Overview",
        "collapsible": true,
        "key": "panel",
        "type": "panel",
        "label": "Panel",
        "input": false,
        "tableView": false,
        "components": [
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "WA Construction Contracts: An Overview",
            "inputMask": "",
            "key": "overviewText1",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "This form is designed to help you through the process of making an adjudication application under the Construction Contracts (Former Provisions) Act 2004 (WA). Please note that this form only applies only to construction work or related goods or services which was carried out in the state of Western Australia",
            "inputMask": "",
            "key": "overviewText2",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "For a more detailed overview of the processes outlined by the Act and its purpose, please follow this link: <a href='https://www.commerce.wa.gov.au/building-and-energy/topic-1-overview-construction-contracts-act' target='_blank'>https://www.commerce.wa.gov.au/building-and-energy/topic-1-overview-construction-contracts-act</a>",
            "inputMask": "",
            "key": "overviewText3",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "radio",
            "label": "My construction work took place in Western Australia",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "workTookPlaceInWA",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "Please note that for an application to be valid it must comply with the requirements of <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s26.html' target='_blank'>s26(1)</a> of the Act otherwise the adjudicator must dismiss it.",
            "inputMask": "",
            "key": "overviewText4",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "In addition, the work must fall within the definition of \"construction work\" as laid out in <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s4.html' target='_blank'>s4</a> of the Act or \"related goods or services\" as laid out in <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s5.html' target='_blank'>s5</a> of the Act",
            "inputMask": "",
            "key": "overviewText5",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "Check that your application meets the following requirements of the Act:",
            "inputMask": "",
            "key": "overviewText6",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "radio",
            "label": "(a) that there is a contract or other agreement, whether in writing or not (ie. a construction contract) <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s25.html' target='_blank'>(s25)</a>:",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s25",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(b) that the work under the contract is 'construction work' or one of the other obligations listed in the defintion of 'construction contract' (<a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s4.html' target='_blank'>s4</a>, <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s5.html' target='_blank'>s5</a>, <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s25.html' target='_blank'>s25</a>):",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s4s5s25",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(c) that none of the exclusions in <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s4.html' target='_blank'>s4(3)</a> apply:",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s4(3)",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(d) that a payment claim was made under the contract",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "paymentClaimMadeUnderContract",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(e) that a payment dispute has arisen because the payment claim has been wholly or partly rejected, or the time for payment of the claim has expired without the responding responding <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s6.html' target='_blank'>(s6)</a>",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s6",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(f) that the Application has been made within 90 business days of the payment dispute arising <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s26.html' target='_blank'>(s26)</a>:",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s26",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(g) that an application for adjudication has not previously been made regarding the payment dispute <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s25.html' target='_blank'>(s25(a))</a>:",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s25a",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(h) that the payment dispute is not the subject of an order, judgement or other finding <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s25.html' target='_blank'>(s25(b))</a>:",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s25b",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(i) that the application sets out the details of, or has attached to it, the construction contract or relevant extracts <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s26.html' target='_blank'>(s26(2)(b))</a>:",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s26(2)(b)ConstructionContract",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "type": "radio",
            "label": "(j) that the Application sets out the details of, or has attached to it, the payment claim <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s26.html' target='_blank'>(s26(2)(b))</a>:",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "s26(2)(b)PaymentContract",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          }
        ]
      },
      {
        "title": "Construction contract",
        "collapsible": false,
        "key": "panel",
        "type": "panel",
        "label": "Panel",
        "input": false,
        "tableView": false,
        "components": [
          {
            "type": "radio",
            "label": "Contract relationship (select most appropriate)",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "contractRelationship",
            "persistent": true,
            values: [
              { value: 'headContractorSubcontractor', label: 'Head contractor/subcontractor' },
              { value: 'headContractorPrincipalOrClient)', label: 'Head contractor/principal (or client)' },
              { value: 'subContractorSubContractor)', label: 'Subcontractor/subcontractor' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "label": "Date the construction contract was entered into between the Applicant and the Respondent",
            "format": "dd-MM-yy",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
              "disableWeekends": false,
              "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "enableTime": false,
            "timePicker": {
              "showMeridian": false
            },
            "key": "dateOfConstruction",
            "type": "datetime",
            "input": true,
            "widget": {
              "type": "calendar",
              "displayInTimezone": "viewer",
              "locale": "en",
              "useLocaleSettings": false,
              "allowInput": true,
              "mode": "single",
              "enableTime": false,
              "noCalendar": false,
              "format": "dd-MMM-yyyy",
              "hourIncrement": 1,
              "minuteIncrement": 1,
              "time_24hr": true,
              "minDate": null,
              "disableWeekends": false,
              "disableWeekdays": false,
              "maxDate": null
            },
            "validate": {
              "required": true,
              "customPrivate": false
            }
          },
          {
            "type": "textarea",
            "input": true,
            "tableView": true,
            "inputType": "text",
            "inputMask": "",
            "label": "Please provide a brief description of your contract",
            "key": "contractDescription",
            "placeholder": "",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "defaultValue": "",
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "radio",
            "label": "Is there a written contract?",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "writtenContract",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            //   "validate": {
            //     "required": true
            // }
          },
          {
            "type": "fileupload",
            "label": "Please provide a copy of this contract or relevant extracts <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s26.html' target='_blank'>(s26(2)(b))</a>.",
            "disabled": false,
            "key":"fileupload_test_1",
            "placeholder": "Construction contract",
            "clearOnHide": false,
            "visible": true,
            "inline": true,
            "tableView": false,
            conditional: {
             // "show": true
              "json": {
                "==": [
                  {
                    "var": "data.formName"
                  },
                  "wa-application"
                ]
              }
            }
          },

        ]
      },

      {
        "title": "Payment Claim",
        "collapsible": false,
        "key": "panel",
        "type": "panel",
        "label": "Panel",
        "input": false,
        "tableView": false,
        "components": [
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": 'If you have carried out relevant work under the Act you may serve a "payment claim" on the party who is liable to pay you. Details of how this should be done will usually be found in your contract. If your contract does not contain information about payment claims then the terms laid out in <a href="https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/sch1.html" target="_blank">Schedule 1 Division 4 of the Act</a> will be implied',
            "inputMask": "",
            "key": "paymentClaimText1",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": 'For further information on making payment claims please click the following link: <a href="https://www.commerce.wa.gov.au/building-and-energy/topic-2-making-payment-claim" target="_blank">https://www.commerce.wa.gov.au/building-and-energy/topic-2-making-payment-claim</a>',
            "inputMask": "",
            "key": "paymentClaimText2",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "radio",
            "label": "Was a payment claim served?",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "wasPaymentClaimServed",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
          {
            "label": "Date payment claim made",
            "format": "dd-MMM-yyyy",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
              "disableWeekends": false,
              "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "enableTime": false,
            "timePicker": {
              "showMeridian": false
            },
            "key": "datePaymentClaimMade",
            "type": "datetime",
            "input": true,
            "widget": {
              "type": "calendar",
              "displayInTimezone": "viewer",
              "locale": "en",
              "useLocaleSettings": false,
              "allowInput": true,
              "mode": "single",
              "enableTime": false,
              "noCalendar": false,
              "format": "dd-MM-yy",
              "hourIncrement": 1,
              "minuteIncrement": 1,
              "time_24hr": true,
              "minDate": null,
              "disableWeekends": false,
              "disableWeekdays": false,
              "maxDate": null
            },
            "validate": {
              "required": true,
              "customPrivate": false
            }
          },
          {
            "label": "Amount claimed (exclusive of GST)",
            "mask": false,
            "spellcheck": true,
            "tableView": false,
            "currency": "AUD",
            "inputFormat": "plain",
            "key": "amountClaimed",
            "type": "currency",
            "input": true,
            "delimiter": true,
            "validate": {
              "required": true,
              "customPrivate": false
            }
          },
          {
            "type": "textfield",
            "input": true,
            "tableView": true,
            "inputType": "text",
            "inputMask": "",
            "label": "Payment claim/Invoice number",
            "key": "paymentClaimOrInvoiceNumber",
            "placeholder": "",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "defaultValue": "",
            "protected": false,
            "unique": false,
            "persistent": true,
            "validate": {
              "required": true,
              "customPrivate": false,
              "pattern": "^[0-9]+$"
            }
          },
          // Add file upload component
          {
            "type": "fileupload",
            "label": "Please provide a copy of the payment claim or relevant details of the payment claim <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s26.html' target='_blank'>(s26(2)(b))</a>",
            "disabled": false,
            "value": 1,
            "placeholder": "Payment claim",
            conditional: {
              "json": {
                "===": [
                  {
                    "var": "data.formName"
                  },
                  "wa-application"
                ]
              }
            }
          }
        ]
      }, //payment claim
      {
        "title": "Payment Dispute",
        "collapsible": false,
        "key": "paymentDisputePanel",
        "type": "panel",
        "label": "Panel",
        "input": false,
        "tableView": false,
        "components": [
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "If you have made a payment claim, and it has either been disputed or not paid, then your eligiblity to apply for adjudication will depend on whether a \"payment dispute\" has arisen. The definition of a payment dispute can be found in <a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s6.html' target='_blank'>s6 of the Act</a>.",
            "inputMask": "",
            "key": "paymentDisputeText1",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "For further information on payment disputes please click the following link:\r\n\r\n <a href='https://www.commerce.wa.gov.au/building-and-energy/topic-3-applying-adjudication' target='_blank'>https://www.commerce.wa.gov.au/building-and-energy/topic-3-applying-adjudication</a>",
            "inputMask": "",
            "key": "paymentDisputeText1",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true
          },
          {
            "label": "Date of payment dispute",
            "format": "dd-MM-yy",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
              "disableWeekends": false,
              "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "enableTime": false,
            "timePicker": {
              "showMeridian": false
            },
            "key": "dateOfPaymentDispute",
            "type": "datetime",
            "input": true,
            "widget": {
              "type": "calendar",
              "displayInTimezone": "viewer",
              "locale": "en",
              "useLocaleSettings": false,
              "allowInput": true,
              "mode": "single",
              "enableTime": false,
              "noCalendar": false,
              "format": "dd-MMM-yyyy",
              "hourIncrement": 1,
              "minuteIncrement": 1,
              "time_24hr": true,
              "minDate": null,
              "disableWeekends": false,
              "disableWeekdays": false,
              "maxDate": null
            },
            "validate": {
              "required": true,
              "customPrivate": false
            }
          },
          {
            "label": "Amount not paid, whether in whole or in part, at the point in time of commencing this application for adjudication (exclusive of GST)",
            "mask": false,
            "spellcheck": true,
            "tableView": false,
            "currency": "AUD",
            "inputFormat": "plain",
            "key": "amountNotPaid",
            "type": "currency",
            "input": true,
            "delimiter": true,
            "validate": {
              "required": true,
              "customPrivate": false
            }
          },
          {
            "type": "radio",
            "label": "Has a notice of dispute been issued?",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "isPaymentDisputeIssued",
            "persistent": true,
            values: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' }
            ],
            "validate": {
              "required": true
            }
          },
         

          {
            "type": "fileupload",
            "label": "Please attach a copy of the notice of dispute",
            "disabled": false,
            "value": 1,
            "placeholder": "Payment dispute",
            conditional: {
              "json": {
                "===": [
                  {
                    "var": "data.formName"
                  },
                  "wa-application"
                ]
              }
            }
          }
        ]
      }, //payment dispute
      {
        "title": "Party details",
        "collapsible": true,
        "key": "panel",
        "type": "panel",
        "label": "Panel",
        "input": false,
        "tableView": false,
        "components": [{
          "title": "Applicant details",
          "collapsible": true,
          "key": "panel",
          "type": "panel",
          "label": "Panel",
          "input": false,
          "tableView": false,
          "components": [
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Name of Applicant (Company)",
              "key": "applicantName",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
 
            }, // Name
            {
              type: "select",
              label: "Business Structure",
              key: "applicantBusinessStructure",
              placeholder: "Select one",
              data: {
                values: [
                  { value: 'Commonwealth Government', label: 'Commonwealth Government' },
                  { value: 'Incorporated Association', label: 'Incorporated Association' },
                  { value: 'Local Government', label: 'Local Government' },
                  { value: 'Ltd Company', label: 'Ltd Company' },
                  { value: 'Local Government', label: 'Local Government' },
                  { value: 'Partnership', label: 'Partnership' },
                  { value: 'Pty Ltd Company', label: 'Pty Ltd Company' },
                  { value: 'Sole trader', label: 'Sole trader' },
                  { value: 'State Government', label: 'State Government' },
                  { value: 'Trust', label: 'Trust' },
                  { value: 'Other', label: 'Other' }
                ]
              },
              dataSrc: "values",
              validate: {
                required: true
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              defaultValue: '',
              template: "<span>{{ item.label }}</span>",
              input: true
            }, // Business Structure
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Contact Person",
              "inputMask": "",
              "key": "applicantContactPersonText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              // "conditional": {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            }, //Contact person
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantContactPersonName",
              "placeholder": "Name",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            }, // Name
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantContactPersonPosition",
              "placeholder": "Position",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            }, // Position
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "ABN/ACN",
              "key": "applicantABN",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false,
                "pattern": "^[0-9]+$"
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            }, //ABN
            {
              "type": "button",
              "label": "Check",
              "key": "check",
              "disableOnInvalid": false,
              "input": true,
              "tableView": true,
              "action": "custom",
              "custom": "window.onCheck(data.applicantABN)",
              // "conditional": {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            }, // ABN Button
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "ABN is valid",
              "inputMask": "",
              "key": "abnValidText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "customClass": "abnSuccess",
              "conditional": {
                "json": {
                  "==": [
                    {
                      "var": "data.displayabnValidationSuccess"
                    },
                    true
                  ]
                }
              }
            }, // ABN Text 1
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "ABN is not valid",
              "inputMask": "",
              "key": "abnNotValidText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "customClass": "abnFailure",
              "conditional": {
                "json": {
                  "==": [
                    {
                      "var": "data.displayabnValidationFailure"
                    },
                    true
                  ]
                }
              }
            }, // ABN text 2
           
            // this is for nsw and all other states
            {
              type: "select",
              label: "Business Type/Activity",
              key: "applicantBusinessType",
              placeholder: "Select one",
              data: {
                values: [
                  { value: 'Principal', label: 'Principal' },
                  { value: 'Head contractor', label: 'Head contractor' },
                  { value: 'Subcontractor', label: 'Subcontractor' },
                  { value: 'Supplier', label: 'Supplier' },
                  { value: 'Consultant', label: 'Consultant' },
                  { value: 'Not Specified', label: 'Not Specified' }
                ]
              },
              dataSrc: "values",
              validate: {
                required: true
              },
              "conditional": {
                "json": {
                  "and": [
                    // {"==": [{"var": "data.terms"}, "yes"]},
                    { "in": [{ "var": "data.applicantState" }, ["NSW", "SA", "ACT", "TAS"]] }
                  ]
                }
              },
              defaultValue: '',
              template: "<span>{{ item.label }}</span>",
              input: true
            },

            // this is for VIC - has special list
            {
              type: "select",
              label: "Business Type/Activity",
              key: "applicantBusinessType",
              placeholder: "Select one",
              data: {
                values: [
                  { value: 'Consultant', label: 'Consultant' },
                  { value: 'Developer', label: 'Developer' },
                  { value: 'Head contractor', label: 'Head contractor' },
                  { value: 'Major subcontractor', label: 'Major subcontractor' },
                  { value: 'Manufacturer of building materials or components', label: 'Manufacturer of building materials or components' },
                  { value: 'Project manager', label: 'Project manager' },
                  { value: 'Supplier', label: 'Supplier' },
                  { value: 'Trade subcontractor', label: 'Trade subcontractor' },
                  { value: 'Other', label: 'Other' }
                ]
              },
              dataSrc: "values",
              validate: {
                required: true
              },
              "conditional": {
                "json": {
                  "and": [
                    // {"==": [{"var": "data.terms"}, "yes"]},
                    { "===": [{ "var": "data.applicantState" }, "VIC"] }
                  ]
                }
              },
              defaultValue: '',
              template: "<span>{{ item.label }}</span>",
              input: true
            },

 
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Address",
              "inputMask": "",
              "key": "applicantAddressText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              // "conditional": {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantAddressNumberStreet",
              "placeholder": "Number/Street",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantSuburb",
              "placeholder": "Suburb",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantState",
              "placeholder": "State",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantPostCode",
              "placeholder": "Postcode",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "label": "Phone",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              "key": "applicantPhone",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Fax",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              "key": "applicantFax",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Email",
              "tableView": true,
              "validate": {
                "required": true
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              "key": "applicantEmail",
              "type": "email",
              "input": true
            },
            {
              type: "select",
              label: "Does the applicant retain advisors?",
              key: "retainAdvisers",
              placeholder: "Select one",
              data: {
                values: [
                  { value: 'claimPreparer', label: 'Claim preparer' },
                  { value: 'consultant', label: 'Consultant' },
                  { value: 'solicitors', label: 'Solicitors' },
                  { value: 'none', label: 'None' },
                  { value: 'notKnown', label: 'Not known' }
                ]
              },
              dataSrc: "values",
              defaultValue: '',
              template: "<span>{{ item.label }}</span>",
              input: true,
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            //start for retain advisors
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Contact Person",
              "inputMask": "",
              "key": "retailAdvisorContactPersonText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorContactPersonName",
              "placeholder": "Name",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorContactPersonPosition",
              "placeholder": "Position",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Address",
              "inputMask": "",
              "key": "retailAdvisorAddressText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorAddressNumberStreet",
              "placeholder": "Number/Street",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorSuburb",
              "placeholder": "Suburb",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorState",
              "placeholder": "State",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorPostCode",
              "placeholder": "Postcode",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "label": "Phone",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "retailAdvisorPhone",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Fax",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "retailAdvisorFax",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Email",
              "tableView": true,
              "validate": {
                "required": true
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "retailAdvisorEmail",
              "type": "email",
              "input": true
            }
          ],
        },
          {
            "title": "Respondent details",
            "collapsible": true,
            "key": "panel",
            "type": "panel",
            "label": "Panel",
            "input": false,
            "tableView": false,
            "components": [
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "Name of Company (Respondent)",
                "key": "respondentName",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                //   conditional: {
                //   "json": {
                //     "===": [
                //       {
                //         "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              }, // Name
              {
                type: "select",
                label: "Business Structure",
                key: "respondentBusinessStructure",
                placeholder: "Select one",
                data: {
                  values: [
                    { value: 'Commonwealth Government', label: 'Commonwealth Government' },
                    { value: 'Incorporated Association', label: 'Incorporated Association' },
                    { value: 'Local Government', label: 'Local Government' },
                    { value: 'Ltd Company', label: 'Ltd Company' },
                    { value: 'Local Government', label: 'Local Government' },
                    { value: 'Partnership', label: 'Partnership' },
                    { value: 'Pty Ltd Company', label: 'Pty Ltd Company' },
                    { value: 'Sole trader', label: 'Sole trader' },
                    { value: 'State Government', label: 'State Government' },
                    { value: 'Trust', label: 'Trust' },
                    { value: 'Other', label: 'Other' }
                  ]
                },
                dataSrc: "values",
                validate: {
                  required: true
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //         "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // },
                defaultValue: '',
                template: "<span>{{ item.label }}</span>",
                input: true
              }, // business structure
              {
                "type": "htmlelement",
                "input": false,
                "tableView": true,
                "content": "Contact Person",
                "inputMask": "",
                "key": "respondentContactPersonText",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "protected": false,
                "unique": false,
                "persistent": true,
                // "conditional": {
                //   "json": {
                //     "===": [
                //       {
                //         "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentContactPersonName",
                "placeholder": "Name",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //         "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentContactPersonPosition",
                "placeholder": "Position",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "customPrivate": false
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //     {
                //       "var": "data.terms"
                //     },
                //     "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "ABN/ACN",
                "key": "respondentABN",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //         "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "button",
                "label": "Check",
                "key": "checkRespondentBN",
                "disableOnInvalid": false,
                "input": true,
                "tableView": true,
                "action": "custom",
                "custom": "window.onCheck1(data.respondentABN)",
                // disabled: "window.checkValid(data.applicantABN)",
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //         "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "htmlelement",
                "input": false,
                "tableView": true,
                "content": "ABN is valid",
                "inputMask": "",
                "key": "abnValidTextRespondent",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "protected": false,
                "unique": false,
                "persistent": true,
                "customClass": "abnSuccess",
                "conditional": {
                  "json": {
                    "==": [
                      {
                        "var": "data.displayabnValidationSuccessRespondent"
                      },
                      true
                    ]
                  }
                }
              },
              {
                "type": "htmlelement",
                "input": false,
                "tableView": true,
                "content": "ABN is not valid",
                "inputMask": "",
                "key": "abnNotValidTextRespondent",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "protected": false,
                "unique": false,
                "persistent": true,
                "customClass": "abnFailure",
                "conditional": {
                  "json": {
                    "==": [
                      {
                        "var": "data.displayabnValidationFailureRespondent"
                      },
                      true
                    ]
                  }
                }
              },            

              // this is for nsw and all other states
              {
                type: "select",
                label: "Business Type/Activity",
                key: "respondentBusinessType",
                placeholder: "Select one",
                data: {
                  values: [
                    { value: 'Principal', label: 'Principal' },
                    { value: 'Head contractor', label: 'Head contractor' },
                    { value: 'Subcontractor', label: 'Subcontractor' },
                    { value: 'Supplier', label: 'Supplier' },
                    { value: 'Consultant', label: 'Consultant' },
                    { value: 'Not Specified', label: 'Not Specified' }
                  ]
                },
                dataSrc: "values",
                validate: {
                  required: true
                },
                "conditional": {
                  "json": {
                    "and": [
                      // {"==": [{"var": "data.terms"}, "yes"]},
                      { "in": [{ "var": "data.applicantState" }, ["NSW", "SA", "ACT", "TAS"]] }
                    ]
                  }
                },
                defaultValue: '',
                template: "<span>{{ item.label }}</span>",
                input: true
              },

              // this is for VIC - has special list
              {
                type: "select",
                label: "Business Type/Activity",
                key: "respondentBusinessType",
                placeholder: "Select one",
                data: {
                  values: [
                    { value: 'Consultant', label: 'Consultant' },
                    { value: 'Developer', label: 'Developer' },
                    { value: 'Head contractor', label: 'Head contractor' },
                    { value: 'Major subcontractor', label: 'Major subcontractor' },
                    { value: 'Manufacturer of building materials or components', label: 'Manufacturer of building materials or components' },
                    { value: 'Project manager', label: 'Project manager' },
                    { value: 'Supplier', label: 'Supplier' },
                    { value: 'Trade subcontractor', label: 'Trade subcontractor' },
                    { value: 'Other', label: 'Other' }
                  ]
                },
                dataSrc: "values",
                validate: {
                  required: true
                },
                "conditional": {
                  "json": {
                    "and": [
                      // {"==": [{"var": "data.terms"}, "yes"]},
                      { "===": [{ "var": "data.applicantState" }, "VIC"] }
                    ]
                  }
                },
                defaultValue: '',
                template: "<span>{{ item.label }}</span>",
                input: true
              },


            
              {
                "type": "htmlelement",
                "input": false,
                "tableView": true,
                "content": "Address",
                "inputMask": "",
                "key": "respondentAddressText",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "protected": false,
                "unique": false,
                "persistent": true,
                // "conditional": {
                //   "json": {
                //     "===": [
                //       {
                //         "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentAddressNumberStreet",
                "placeholder": "Number/Street",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //     {
                //       "var": "data.terms"
                //     },
                //     "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentSuburb",
                "placeholder": "Suburb",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //     {
                //       "var": "data.terms"
                //     },
                //     "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentState",
                "placeholder": "State",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //       "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentPostCode",
                "placeholder": "Postcode",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //       "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              },
              {
                "label": "Phone",
                "inputMask": "(99) 9999-9999",
                "tableView": true,
                "persistent": true,
                "validate": {
                  "required": false,
                  "customPrivate": false
                },
                // conditional: {
                // "json": {
                // "===": [
                //   {
                //   "var": "data.terms"
                //   },
                //   "yes"
                // ]
                // }
                // },
                "key": "respondentPhone",
                "type": "textfield",
                "input": true
              },
              {
                "label": "Fax",
                "inputMask": "(99) 9999-9999",
                "tableView": true,
                "persistent": true,
                "validate": {
                  "required": false,
                  "customPrivate": false
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //       "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // },
                "key": "respondentFax",
                "type": "textfield",
                "input": true
              },
              {
                "label": "Email",
                "tableView": true,
                "validate": {
                  "required": true
                },
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //       "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // },
                "key": "respondentEmail",
                "type": "email",
                "input": true
              },
              {
                type: "select",
                label: "Does the respondent retain advisors?",
                key: "respondentRetainAdvisers",
                placeholder: "Select one",
                data: {
                  values: [
                    { value: 'responsePreparer', label: 'Response preparer' },
                    { value: 'consultant', label: 'Consultant' },
                    { value: 'solicitors', label: 'Solicitors' },
                    { value: 'none', label: 'None' },
                    { value: 'notKnown', label: 'Not known' }
                  ]
                },
                dataSrc: "values",
                defaultValue: '',
                template: "<span>{{ item.label }}</span>",
                input: true,
                // conditional: {
                //   "json": {
                //     "===": [
                //       {
                //       "var": "data.terms"
                //       },
                //       "yes"
                //     ]
                //   }
                // }
              },
              //start for retain advisors
              {
                "type": "htmlelement",
                "input": false,
                "tableView": true,
                "content": "Contact Person",
                "inputMask": "",
                "key": "respondentRetailAdvisorContactPersonText",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "protected": false,
                "unique": false,
                "persistent": true,
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentRetailAdvisorContactPersonName",
                "placeholder": "Name",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentRetailAdvisorContactPersonPosition",
                "placeholder": "Position",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "customPrivate": false
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                }
              },
              {
                "type": "htmlelement",
                "input": false,
                "tableView": true,
                "content": "Address",
                "inputMask": "",
                "key": "respondentRetailAdvisorAddressText",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "protected": false,
                "unique": false,
                "persistent": true,
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentRetailAdvisorAddressNumberStreet",
                "placeholder": "Number/Street",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentRetailAdvisorSuburb",
                "placeholder": "Suburb",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentRetailAdvisorState",
                "placeholder": "State",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "",
                "key": "respondentRetailAdvisorPostCode",
                "placeholder": "Postcode",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                }
              },
              {
                "label": "Phone",
                "inputMask": "(99) 9999-9999",
                "tableView": true,
                "persistent": true,
                "validate": {
                  "required": false,
                  "customPrivate": false
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                },
                "key": "respondentRetailAdvisorPhone",
                "type": "textfield",
                "input": true
              },
              {
                "label": "Fax",
                "inputMask": "(99) 9999-9999",
                "tableView": true,
                "persistent": true,
                "validate": {
                  "required": false,
                  "customPrivate": false
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                },
                "key": "respondentRetailAdvisorFax",
                "type": "textfield",
                "input": true
              },
              {
                "label": "Email",
                "tableView": true,
                "validate": {
                  "required": true
                },
                conditional: {
                  "json": {
                    "in": [
                      {
                        "var": "data.respondentRetainAdvisers"
                      },
                      ["responsePreparer", "consultant", "solicitors"]
                    ]
                  }
                },
                "key": "respondentRetailAdvisorEmail",
                "type": "email",
                "input": true
              }
            ],
            // conditional: {
            //   "json": {
            //     "===": [
            //       {
            //         "var": "data.terms"
            //       },
            //       "yes"
            //     ]
            //   }
            // }
          }, // respondant details
          {
            "title": "Prescribed Appointer",
            "collapsible": true,
            "key": "prescribedAppointerPanel",
            "type": "panel",
            "label": "Panel",
            "input": false,
            "tableView": false,
            "components": [
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "Company Name",
                "key": "prescribedAppointerName",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "disabled": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                }
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "ABN/ACN",
                "key": "prescribedAppointerABN",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "disabled": true,
                //"validate": {
                //  "required": true,
                //  "customPrivate": false
                //}
              },
              //{
              //  "type": "button",
              //  "label": "Check",
              //  "key": "checkPrescribedAppointerABN",
              //  "disableOnInvalid": false,
              //  "input": true,
              //  "tableView": true,
              //  "action": "custom",
              //  "custom": "window.onCheck3(data.prescribedAppointerABN)"
              //},
              //{
              //  "type": "htmlelement",
              //  "input": false,
              //  "tableView": true,
              //  "content": "ABN is valid",
              //  "inputMask": "",
              //  "key": "abnValidTextPrescribedAppointer",
              //  "prefix": "",
              //  "suffix": "",
              //  "multiple": false,
              //  "protected": false,
              //  "unique": false,
              //  "persistent": true,
              //  "customClass": "abnSuccess",
              //  "conditional": {
              //    "json": {
              //      "==": [
              //        {
              //          "var": "data.displayabnValidationSuccessPrescribedAppointer"
              //        },
              //        true
              //      ]
              //    }
              //  }
              //},
              //{
              //  "type": "htmlelement",
              //  "input": false,
              //  "tableView": true,
              //  "content": "ABN is not valid",
              //  "inputMask": "",
              //  "key": "abnNotValidTextPrescribedAppointer",
              //  "prefix": "",
              //  "suffix": "",
              //  "multiple": false,
              //  "protected": false,
              //  "unique": false,
              //  "persistent": true,
              //  "customClass": "abnFailure",
              //  "conditional": {
              //    "json": {
              //      "==": [
              //        {
              //          "var": "data.displayabnValidationFailurePrescribedAppointer"
              //        },
              //        true
              //      ]
              //    }
              //  }
              //},

              // Start - Address, tele and email
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "Address Line 1",
                "key": "prescribedAppointerPostalAddress1",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                "disabled": true,
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "Address Line 2",
                "key": "prescribedAppointerPostalAddress2",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  // "required": true,
                  "customPrivate": false
                },
                "disabled": true,
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "Suburb",
                "key": "prescribedAppointerSuburb",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                "disabled": true,
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "State",
                "key": "prescribedAppointerState",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false
                },
                "disabled": true,
              },
              {
                "type": "textfield",
                "input": true,
                "tableView": true,
                "inputType": "text",
                "inputMask": "",
                "label": "PostCode",
                "key": "prescribedAppointerPostCode",
                "placeholder": "",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "defaultValue": "",
                "protected": false,
                "unique": false,
                "persistent": true,
                "validate": {
                  "required": true,
                  "customPrivate": false,
                  "pattern": "^[0-9]+$"
                },
                "disabled": true,
              },
              {
                "label": "Telephone number",
                //"inputMask": "(99) 9999-9999",
                "tableView": true,
                "persistent": true,
                "validate": {
                  "required": false,
                  "customPrivate": false
                },
                "key": "prescribedAppointerTelephoneNumber",
                "type": "textfield",
                "input": true,
                "disabled": true,
              },
              {
                "label": "Fax number",
                //"inputMask": "(99) 9999-9999",
                "tableView": true,
                "persistent": true,
                "validate": {
                  "required": false,
                  "customPrivate": false
                },
                "key": "prescribedAppointerFaxNumber",
                "type": "textfield",
                "input": true,
                "disabled": true,
              },
              {
                "label": "Email",
                "tableView": true,
                "validate": {
                  "required": true
                },
                "key": "prescribedAppointerEmail",
                "type": "email",
                "input": true,
                "disabled": true,
              },
            ]
          }, // prescribed appointer
          {
            "title": "Extra Submissions",
            "collapsible": false,
            "key": "panel",
            "type": "panel",
            "label": "Panel",
            "input": false,
            "tableView": false,
            "components": [
              {
                "type": "htmlelement",
                "input": false,
                "tableView": true,
                "content": "<a href='https://www.austlii.edu.au/cgi-bin/viewdoc/au/legis/wa/consol_act/ccpa2004499/s26.html' target='_blank'>s26(2)(c) of the Act</a> requires that all the information, documentation and submissions on which the applicant relies is attached to this form.",
                "inputMask": "",
                "key": "paymentDisputeText",
                "prefix": "",
                "suffix": "",
                "multiple": false,
                "protected": false,
                "unique": false,
                "persistent": true
              },
              {
                "type": "fileupload",
                "label": "Submissions",
                "disabled": false,
                "placeholder": "Extra submissions",
                conditional: {
                  "json": {
                    "===": [
                      {
                        "var": "data.formName"
                      },
                      "wa-application"
                    ]
                  }
                }
              },
              {
                "type": "fileupload",
                "label": "Attachments",
                "disabled": false,
                "placeholder": "Attachments",
                conditional: {
                  "json": {
                    "===": [
                      {
                        "var": "data.formName"
                      },
                      "wa-application"
                    ]
                  }
                }
              },
            ]
          }, //extra submissions

        ]
      },
      //applicant details

      //end for retain advisors

      // start all fields from beginning for respondant
     

    

      // Add the abn check

      {
        "label": "Date of service of application on Respondent",
        "format": "dd-MMM-yyyy",
        "tableView": false,
        "enableMinDateInput": false,
        "datePicker": {
          "disableWeekends": false,
          "disableWeekdays": false
        },
        "enableMaxDateInput": false,
        "enableTime": false,
        "timePicker": {
          "showMeridian": false
        },
        "key": "dateOfServiceOfApplicationOnPrescribedAppointorRespondent",
        "type": "datetime",
        "input": true,
        "widget": {
          "type": "calendar",
          "displayInTimezone": "viewer",
          "locale": "en",
          "useLocaleSettings": false,
          "allowInput": true,
          "mode": "single",
          "enableTime": false,
          "noCalendar": false,
          "format": "dd-MMM-yyyy",
          "hourIncrement": 1,
          "minuteIncrement": 1,
          "time_24hr": true,
          "minDate": null,
          "disableWeekends": false,
          "disableWeekdays": false,
          "maxDate": null
        },
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "button",
        "label": "Submit",
        "key": "submit",
        "disableOnInvalid": false,
        "input": true,
        "tableView": false
      }
    ];

    Formio.createForm(document.getElementById('formio'), {
        "components": formComponents
    }).then(function(form) {
      formData = form;
      if (jsonDataUrl != undefined) {
        httpClient.get<any>(that.baseUrl+ 'api/SampleData/GetJsonData?filepath=' + jsonDataUrl).subscribe(data1 => {
          form.submission = {
            data: data1
          }
        })
      } else {
        formData.submission ={data: {...formData.submission.data, ...{formId: Guid.create().toJSON().value}, ...{formName: 'wa-application'}, ...{prescribedAppointerName: 'Resolution Institute',
                              ...{prescribedAppointerABN: '69008651232'}, ...{prescribedAppointerPostalAddress1: 'Suite 602, Level 6, Tower B, Zenith Centre'},
                              ...{prescribedAppointerPostalAddress2: '821-843 Pacific Highway'}, ...{prescribedAppointerState: 'NSW'},
                              ...{prescribedAppointerSuburb: 'Chatswood'}, ...{prescribedAppointerPostCode: '2067'},
                            ...{prescribedAppointerTelephoneNumber: '(02) 9251 3366'}, ...{prescribedAppointerFaxNumber: '(02) 9251 3733'},
                            ...{prescribedAppointerEmail: 'nominations@resolution.institute'}}}}
      }

      form.on('submit', function(form: any) {
        var serviceResponse = that.appService.getUrls();
        var pdfUrl = "/documents/" + formId +".pdf";
            var pdfData = {
              "key": AppService.generatedPdfKey,
              "url": []
            };
        pdfData.url.push(pdfUrl);
        serviceResponse.push(pdfData);
        let today = new Date();
        form.data.submission_date = today.toString();
        form.data.files_submitted = that.appService.getUploadedFilesString();
        var jsonToServer = { ...form.data, ...{ files: serviceResponse } };

        let jsonToServer_ = JSON.parse(JSON.stringify(jsonToServer))

        
        today.setHours(0, 0, 0, 0);
        let newComponent = {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Date Submitted",
          "key": "submission_date",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "Test_Default",
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.submission_date"
                },
                "yes"
              ]
            }
          }
        };
        
        let filesComponent = {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Files Submitted",
          "key": "files_submitted",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "Test_Default",
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.files_submitted"
                },
                "yes"
              ]
            }
          }
        };
        let panel = {
          "title": "Form details",
          "key": "panel",
          "type": "panel",
          "components": [newComponent, filesComponent]
        }

        formComponents.unshift(<any>panel);
        let component = {
          type: 'form',
          title: 'Resolution Institute Quickfiles application',
          display: 'form',
          components: formComponents
        };

        let submission = {
          //owner: jsonToServer_.formName,
          //_id: formId,
          //modified: today.toString(),
          data: jsonToServer
        };

        let options = {
          ignoreLayout: true
        };

        let exporter = new FormioExport(component, submission, options);

        let config = {
          download: false,
          filename: formId + '.pdf'
        };
        var pdfFileName = config.filename;
        /*
        exporter.toPdf(config).then((pdf) => {
          // download the pdf file
          pdf.save(config.filename);
        });
        */

        exporter.toPdf(config).then((pdf) => {
          return pdf.output('datauristring');
        }).then((datauri_base64) => {
          if (datauri_base64) {
            // console.log(datauri_base64);

            var pdfObject = {};
            pdfObject["base64file"] = datauri_base64;
            pdfObject["filename"] = pdfFileName;

            that.httpClient.post<any>(that.baseUrl + 'api/SampleData/SaveToPdf', pdfObject).subscribe(result => {
              if (result) {
                console.log('PDF uploaded!!');

                that.httpClient.post<any>(that.baseUrl + 'api/SampleData/PostFormData', jsonToServer).subscribe(result => {
                  if (result) {
                    console.log('Form data uploaded!!');

                    that.router.navigateByUrl('/wa-thankyou');
                  }
                  else {
                    alert('There was an error with the submision, please try again. -1');

                    return false;
                  }
                }, error => {
                  console.error(error);

                  return false;
                });
              }
              else {
                alert('There was an error with the submision, please try again. -2');

                return false;
              }
            }, error => {
              console.error(error);

              return false;
            });
          }
        }).catch(function (error) {
          alert('There was an error with the submision, please try again. -3');

          return false;
        });

      });
    });
    // this.formData = {
    //     data: {
    //       "firstName": "",
    //       "lastName": ""
    //     }
    //   };'
    (window as any).onCheck = function onCheck(abnVal: any){
      that.ngxLoader.start();
      formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: false}, ...{displayabnValidationFailure: false}}}
    // console.log("abnVal is" + abnVal);
    // console.log("form is", formData);
    httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
      if(result.ABRPayloadSearchResults.response.businessEntity) {
          formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: true}, ...{displayabnValidationFailure: false}}}
      } else {
          formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: false}, ...{displayabnValidationFailure: true}}}
      }
      that.ngxLoader.stop();
  });
  };
  
  (window as any).onCheck1 = function onCheck1(abnVal: any){
      that.ngxLoader.start();
      formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: false}, ...{displayabnValidationFailureRespondent: false}}}
    // console.log("abnVal is" + abnVal);
    // console.log("form is", formData);
    httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
      if(result.ABRPayloadSearchResults.response.businessEntity) {
          formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: true}, ...{displayabnValidationFailureRespondent: false}}}
      } else {
          formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: false}, ...{displayabnValidationFailureRespondent: true}}}
      }
      that.ngxLoader.stop();
  });
  };

  (window as any).onCheck2 = function onCheck2(abnVal: any){
    that.ngxLoader.start();
    formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessAdjudicator: false}, ...{displayabnValidationFailureAdjudicator: false}}}
  // console.log("abnVal is" + abnVal);
  // console.log("form is", formData);
  httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
    if(result.ABRPayloadSearchResults.response.businessEntity) {
        formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessAdjudicator: true}, ...{displayabnValidationFailureAdjudicator: false}}}
    } else {
        formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessAdjudicator: false}, ...{displayabnValidationFailureAdjudicator: true}}}
    }
    that.ngxLoader.stop();
  });
  };
  (window as any).onCheck3 = function onCheck3(abnVal: any){
    that.ngxLoader.start();
    formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessPrescribedAppointer: false}, ...{displayabnValidationFailurePrescribedAppointer: false}}}
  // console.log("abnVal is" + abnVal);
  // console.log("form is", formData);
  httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
    if(result.ABRPayloadSearchResults.response.businessEntity) {
        formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessPrescribedAppointer: true}, ...{displayabnValidationFailurePrescribedAppointer: false}}}
    } else {
        formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessPrescribedAppointer: false}, ...{displayabnValidationFailurePrescribedAppointer: true}}}
    }
    that.ngxLoader.stop();
  });
  };
  }
  onSubmit(form: any) {
    var serviceResponse = this.appService.getUrls();
    var jsonToServer = {...form.data, ...{files: serviceResponse}};
    console.log(jsonToServer);
    this.httpClient.post<any>(this.baseUrl + 'api/SampleData/PostFormData', jsonToServer).subscribe(result => {
      if (result) {
        console.log('the form data is submitted to queue')
      this.router.navigateByUrl('/wa-thankyou');
      } else {
        console.log('form is not saved');
      }
    }, error => {
      console.error(error)
      // display a message that the form is not saved
    });
  }
}
